import { mapState, mapActions } from 'vuex';

import currentViewMixin from '@/mixins/currentView';

import { ActionButton } from '@/components/Common/Dialog';
import { IFRAME_EVENT_MESSAGE } from '@/utils/consts';

export const ErrorActionButtons = {
    name: 'ErrorActionButtons',
    mixins: [currentViewMixin],
    props: {
        canReload: {
            type: Boolean,
        },
        canGoToConnection: {
            type: Boolean,
        },
        callback: {
            type: Function,
        },
        widget: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {
        ...mapState('dashboardHeader', ['widgetRefresh$']),
    },
    methods: {
        ...mapActions('iframe', ['postIframeMessage']),
    },
    render() {
        return (
            <div class="widget-error-panel__item__button-wrapper">
                {this.canReload && (
                    <ActionButton
                        onClick={() => {
                            // 기존에는 에러가 나는 계정을 adAccounts으로 넘겼는데, 예 next({adAccounts})
                            // 에러가 나는 계정만 재패치해주는 문제를 방지하기 위해 프롭을 뺌
                            if (this.isReactDashboard) {
                                this.postIframeMessage({
                                    type: IFRAME_EVENT_MESSAGE.REFRESH_WIDGET_DATA,
                                    data: {
                                        id: this.widget.id,
                                    },
                                });

                                if (this.callback) {
                                    this.postIframeMessage({
                                        type: IFRAME_EVENT_MESSAGE.REFRESH_CHILDREN_DATA,
                                        data: {
                                            widget: this.widget,
                                        },
                                    });
                                }

                                this.$emit('setLoading', true);

                                setTimeout(() => {
                                    this.$emit('setLoading', false);
                                }, 2000);
                            } else {
                                this.widgetRefresh$.next();
                                this.callback && this.callback();
                            }

                            this.$emit('cancel');
                        }}
                    >
                        {this.$t('WIDGET.cta_reload')}
                    </ActionButton>
                )}

                {this.canGoToConnection && (
                    <ActionButton
                        onClick={() =>
                            this.$router.push({
                                name: 'Connection',
                            })
                        }
                    >
                        {this.$t('WIDGET.cta_go_to_dashboard')}
                    </ActionButton>
                )}
            </div>
        );
    },
};
